/** Limitations for Unscrambler. They apply both to Finder's Component search
 * box and to Unscrambler API calls.
 */
export const UNSCRAMBLER_MIN_LENGTH = 2;
export const UNSCRAMBLER_MAX_LENGTH = 20;
export const UNSCRAMBLER_MAX_WILDCARDS = 3;
export const API_MAX_RESULTS = 2500;

/**
 * Default settings for Finder's Component
 */
export const DEFAULT_WORDLENGTH = 5;
export const DEFAULT_EXACTMATCH = false;

/**
 * Names for sorting orders to make code more readable. Please don't modify
 * these values
 */
export const ASC = 1;
export const DESC = -1;

/**
 * Default sorting column field name for result tables. If not available, the
 * last right handed side column we'll be used instead.
 */
export const DEFAULT_TABLE_SORTING = "wwf_score";

export const GAME_TYPES = {
	FOUR_PICS: "4pics1word",
	SCRABBLE: "scrabble",
	UNSCRAMBLE: "unscramble",
	WORDSLISTS: "words-lists",
};

export const SORT_RESULTS_OPTIONS = ["wordlength", "totalpoints"];

export const DEFAULT_SORT_RESULTS = SORT_RESULTS_OPTIONS[0];

/**
 * References to words lists. For readability's sake.
 */
export const WORDS = {
	STARTING: "starts",
	HAVING: "contains",
	ENDING: "ends",
	LENGTH: "length",
	GENERAL: "general",
};

/**
 * Score tables for Word Games.
 * Even though Unscrambler API provides those scores if explicitly queried.
 * It appears to be better to ask just for plain words and calculate scores on
 * client.
 */
export const SCORES = {
	SCRABBLE: {
		a: 1,
		b: 3,
		c: 3,
		d: 2,
		e: 1,
		f: 4,
		g: 2,
		h: 4,
		i: 1,
		j: 8,
		k: 5,
		l: 1,
		m: 3,
		n: 1,
		o: 1,
		p: 3,
		q: 10,
		r: 1,
		s: 1,
		t: 1,
		u: 1,
		v: 4,
		w: 4,
		x: 8,
		y: 4,
		z: 10,
	},
	WWF: {
		a: 1,
		b: 4,
		c: 4,
		d: 2,
		e: 1,
		f: 4,
		g: 3,
		h: 3,
		i: 1,
		j: 10,
		k: 5,
		l: 2,
		m: 4,
		n: 2,
		o: 1,
		p: 4,
		q: 10,
		r: 1,
		s: 1,
		t: 1,
		u: 2,
		v: 5,
		w: 4,
		x: 8,
		y: 3,
		z: 10,
	},
};

export const SORT_RESULTS_KEYNAME = "selected-sort";

export const FILTER_KEYNAME = "selected-filter";

export const DIGRAPHS = ["ch", "ll", "rr"];
